"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Instagram, Twitter, ArrowUp, MapPin, Phone, Mail, Clock } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        {[{
        label: "The Estate",
        href: "/EstatePage"
      }, {
        label: "Curated Services",
        href: "/CuratedServicesPage"
      }, {
        label: "Begin Your Journey",
        href: "/BeginYourJourneyPage"
      }, {
        label: "Privacy Policy",
        href: "#"
      }].map((item, i) => <li key={i} data-index={i}>
            <Link to={item.href} className="text-sm font-sans text-muted-foreground transition-colors duration-300 hover:text-primary">
              {item.label}
            </Link>
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm font-sans text-muted-foreground transition-colors duration-300 hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const scrollToTop = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  };
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }];
  return <section data-section-id="264921" id="footer" className="dark bg-background text-foreground border-t border-border/20 pt-20 pb-8">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-10 w-auto text-foreground" />
            </Link>
            <p className="text-sm font-sans text-muted-foreground leading-relaxed max-w-xs">
              VOW is a premium wedding venue offering couples an elegant, customizable setting for their special day. We create timeless experiences in a picturesque location.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-medium mb-6 tracking-widest uppercase text-foreground">Navigation</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-medium mb-6 tracking-widest uppercase text-foreground">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm font-sans text-muted-foreground group">
                <MapPin className="size-4 mt-0.5 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  1200 Estate Drive, Champagne Valley
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm font-sans text-muted-foreground group">
                <Phone className="size-4 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  +1 (555) 800-VOWS
                </span>
              </li>
              <li className="flex items-center gap-3 text-sm font-sans text-muted-foreground group">
                <Mail className="size-4 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  concierge@vowvenue.com
                </span>
              </li>
              <li className="flex items-start gap-3 text-sm font-sans text-muted-foreground group pt-2">
                <Clock className="size-4 mt-0.5 shrink-0 transition-colors duration-300 group-hover:text-primary" strokeWidth={1} />
                <span className="transition-colors duration-300 group-hover:text-primary">
                  Tours: Mon-Sun 9:00 AM - 6:00 PM
                </span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default text-lg font-medium mb-6 tracking-widest uppercase text-foreground">Connect</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.href} aria-label={social.label} className="flex size-10 items-center justify-center rounded-md border border-border/30 bg-transparent text-muted-foreground transition-all duration-500 hover:border-primary hover:text-primary hover:shadow-md">
                    <Icon className="size-4" strokeWidth={1} />
                  </Link>;
            })}
            </div>
          </div>

        </div>

        <Separator className="bg-border/20 mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[10px] font-sans uppercase tracking-widest text-muted-foreground">
            &copy; {currentYear} VOW Wedding Venue. All rights reserved.
          </p>
          
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-muted-foreground hover:text-primary hover:bg-transparent gap-2 text-[10px] font-mono uppercase tracking-widest">
            Back to Top
            <ArrowUp className="size-3" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </section>;
}